export const SPECIFC_SPACE_CREDS: string = 'SPECIFC_SPACE_CREDS'
export const SPECIFC_PROJECT_CREDS: string = 'SPECIFC_PROJECT_CREDS'
export const SPECIFC_CMS_CREDS: string = 'SPECIFC_CMS_CREDS'
export const SET_SHOPIFY_COLLECTION_NAME: string = 'SET_SHOPIFY_COLLECTION_NAME'
